import axios, { AxiosHeaders } from "axios"
import axiosRetry from "axios-retry"

import { AppFunctions } from "@others/AppFunctions.ts"
import { applyAppRequestMetadata } from "@others/appRequestMetadata.ts"

const backofficeApi = axios.create({
	timeout: 100000,
	headers: {
		"Content-Type": "application/json",
	},
})

backofficeApi.interceptors.request.use(
	(config) => {
		const authToken = AppFunctions.getViteEnv(
			"VITE_BACKOFFICE_CHAT_AI_CONTROL_AUTH_TOKEN"
		)

		const headers = AxiosHeaders.from(config.headers || {})

		if (authToken) {
			headers.set("Authorization", `Bearer ${authToken}`)
		}

		config.headers = headers

		return applyAppRequestMetadata(config)
	},
	(error) => Promise.reject(error)
)

axiosRetry(backofficeApi, {
	retries: 3,
	retryDelay: axiosRetry.exponentialDelay,
})

export default backofficeApi
